import { create } from 'zustand'
import type { MobData } from '@/mobs/types'

interface MountState {
  mounted: boolean
  activeMob: MobData | null
  nearHorse: boolean

  // Actions
  mount: (mob: MobData) => void
  dismount: () => void
  setNearHorse: (near: boolean) => void
}

export const useMountStore = create<MountState>((set, get) => ({
  mounted: false,
  activeMob: null,
  nearHorse: false,

  mount: (mob) => {
    mob.mounted = true
    set({ mounted: true, activeMob: mob, nearHorse: false })
  },

  dismount: () => {
    const { activeMob } = get()
    if (activeMob) {
      activeMob.mounted = false
    }
    set({ mounted: false, activeMob: null })
  },

  setNearHorse: (near) => {
    if (get().nearHorse !== near) set({ nearHorse: near })
  },
}))
